var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.5 1.5h13.5v3h-13.5v-3z"}}),_c('path',{attrs:{"d":"M12 9.5h-9.5v-3h9.5v3z"}}),_c('path',{attrs:{"d":"M8 14.5h-5.5v-3h5.5v3z"}}),_c('path',{attrs:{"d":"M0 0h1.5v16h-1.5v-16z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }